import { ApiCall } from '@dto/api-calls.dto';
import { createReducer, on } from '@ngrx/store';
import {
  loadChannelProducts, loadChannelProductsFailure, loadChannelProductsSuccess,
  loadChatGroupProducts, loadChatGroupProductsFailure, loadChatGroupProductsSuccess,
  loadChatSingleProducts, loadChatSingleProductsFailure, loadChatSingleProductsSuccess,
  loadEmailProducts, loadEmailProductsFailure, loadEmailProductsSuccess,
  loadPublicEmailProducts, loadPublicEmailProductsFailure, loadPublicEmailProductsSuccess,
  loadSmsProducts, loadSmsProductsFailure, loadSmsProductsSuccess,
} from './products.action';

export interface ProductsState {
  emailEventTypesByProductId: ApiCall<{ [productId: string]: string[] }>;
  publicEmailEventTypesByProductId: ApiCall<{ [productId: string]: string[] }>;
  smsEventTypesByProductId: ApiCall<{ [productId: string]: string[] }>;
  chatSingleCodesByProductId: ApiCall<{ [productId: string]: string[] }>;
  chatGroupCodesByProductId: ApiCall<{ [productId: string]: string[] }>;
  channelProductIds: ApiCall<string[]>;
}

export const initialStateProducts: ProductsState = {
  emailEventTypesByProductId: { data: {}, isLoading: false, error: null, hasBeenCalled: false },
  publicEmailEventTypesByProductId: { data: {}, isLoading: false, error: null, hasBeenCalled: false },
  smsEventTypesByProductId: { data: {}, isLoading: false, error: null, hasBeenCalled: false },
  chatSingleCodesByProductId: { data: {}, isLoading: false, error: null, hasBeenCalled: false },
  chatGroupCodesByProductId: { data: {}, isLoading: false, error: null, hasBeenCalled: false },
  channelProductIds: { data: [], isLoading: false, error: null, hasBeenCalled: false },
};

export const productsReducer = createReducer(
  initialStateProducts,

  // Email
  on(loadEmailProducts, (state) => ({
    ...state,
    emailEventTypesByProductId: { ...state.emailEventTypesByProductId, isLoading: true, error: null },
  })),
  on(loadEmailProductsSuccess, (state, { emailEventTypesByProductId }) => ({
    ...state,
    emailEventTypesByProductId: { data: emailEventTypesByProductId, isLoading: false, error: null, hasBeenCalled: true },
  })),
  on(loadEmailProductsFailure, (state, { error }) => ({
    ...state,
    emailEventTypesByProductId: { ...state.emailEventTypesByProductId, isLoading: false, error, hasBeenCalled: true },
  })),

  // Public email
  on(loadPublicEmailProducts, (state) => ({
    ...state,
    publicEmailEventTypesByProductId: { ...state.publicEmailEventTypesByProductId, isLoading: true, error: null },
  })),
  on(loadPublicEmailProductsSuccess, (state, { publicEmailEventTypesByProductId }) => ({
    ...state,
    publicEmailEventTypesByProductId: { data: publicEmailEventTypesByProductId, isLoading: false, error: null, hasBeenCalled: true },
  })),
  on(loadPublicEmailProductsFailure, (state, { error }) => ({
    ...state,
    publicEmailEventTypesByProductId: { ...state.publicEmailEventTypesByProductId, isLoading: false, error, hasBeenCalled: true },
  })),

  // SMS
  on(loadSmsProducts, (state) => ({
    ...state,
    smsEventTypesByProductId: { ...state.smsEventTypesByProductId, isLoading: true, error: null },
  })),
  on(loadSmsProductsSuccess, (state, { smsEventTypesByProductId }) => ({
    ...state,
    smsEventTypesByProductId: { data: smsEventTypesByProductId, isLoading: false, error: null, hasBeenCalled: true },
  })),
  on(loadSmsProductsFailure, (state, { error }) => ({
    ...state,
    smsEventTypesByProductId: { ...state.smsEventTypesByProductId, isLoading: false, error, hasBeenCalled: true },
  })),

  // Chat singles
  on(loadChatSingleProducts, (state) => ({
    ...state,
    chatSingleCodesByProductId: { ...state.chatSingleCodesByProductId, isLoading: true, error: null },
  })),
  on(loadChatSingleProductsSuccess, (state, { chatSingleCodesByProductId }) => ({
    ...state,
    chatSingleCodesByProductId: { data: chatSingleCodesByProductId, isLoading: false, error: null, hasBeenCalled: true },
  })),
  on(loadChatSingleProductsFailure, (state, { error }) => ({
    ...state,
    chatSingleCodesByProductId: { ...state.chatSingleCodesByProductId, isLoading: false, error, hasBeenCalled: true },
  })),

  // Chat groups
  on(loadChatGroupProducts, (state) => ({
    ...state,
    chatGroupCodesByProductId: { ...state.chatGroupCodesByProductId, isLoading: true, error: null },
  })),
  on(loadChatGroupProductsSuccess, (state, { chatGroupCodesByProductId }) => ({
    ...state,
    chatGroupCodesByProductId: { data: chatGroupCodesByProductId, isLoading: false, error: null, hasBeenCalled: true },
  })),
  on(loadChatGroupProductsFailure, (state, { error }) => ({
    ...state,
    chatGroupCodesByProductId: { ...state.chatGroupCodesByProductId, isLoading: false, error, hasBeenCalled: true },
  })),

  // Channels
  on(loadChannelProducts, (state) => ({
    ...state,
    channelProductIds: { ...state.channelProductIds, isLoading: true, error: null },
  })),
  on(loadChannelProductsSuccess, (state, { channelProductIds }) => ({
    ...state,
    channelProductIds: { data: channelProductIds, isLoading: false, error: null, hasBeenCalled: true },
  })),
  on(loadChannelProductsFailure, (state, { error }) => ({
    ...state,
    channelProductIds: { ...state.channelProductIds, isLoading: false, error, hasBeenCalled: true },
  })),
);
